import { DecorationModel } from "../_model/DecorationModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { ControllerConnection } from "../connection/controllerConnection";
import { Types } from "../../utils/nodeTypes";
import { GetSixConections } from "../../utils/tools";
import * as d3 from "d3";
import Resize from "../_decorationTools/risezeClass";
import { SingletonInter } from "../_service/singletonInter";

export class DecorationArea extends DecorationModel {
    constructor() {
        super("DecorationArea");

        this.node = null;
        this.moved = false;
        let resize = new Resize();

        this.typeConn = new Types().Connection;
        this.transientConnection = null;
        this.ctrConnection = new ControllerConnection();
       

        this.init = async function(newNode, openDialog, openArea) {
            let svg = SingletonFlowchart.svg;
            this.openArea = openArea;
            this.node = newNode;
            
            await svg
                .data([newNode])
                .append("g")
                .classed(`Area-${newNode.areaInfo.idImg}`, true)
                .on("mouseover", resize.mouseOver)
                .on("mouseout", resize.mouseOut)
                .call(this.setDrag(newNode))
                .attr("id", `${newNode.idName}`);

            let g = d3.select(`#${newNode.idName}`);

            g.append("image")
                .classed(`Area-${newNode.id}`, true)
                .attr("width", newNode.width)
                .attr("height", newNode.height)
                .attr("x", (d) => d.x)
                .attr("y", (d) => d.y)
                .attr("stroke-width", newNode.stroke)
                .attr("xlink:href", this.getImagePath(newNode))
                .style("cursor", "pointer") 
                .call(this.setDrag(newNode))
                .on("dblclick", this.setDoubleClick)
                .on("click",  this.setOnClick)
                .append("title")
                .text( SingletonInter.$t('clique-aqui') + ": " + SingletonInter.$t(newNode.areaInfo.name))
                .node();

                resize.apply(g, newNode)

            this.createConnections(newNode);
            this.createConnectionPath(newNode, openArea);
            return svg;
        };

        this.setOnClick = () => {
            if (this.node.readOnly) {
                return this.openArea(this.node.areaInfo.name);
            }
        }

        this.setDoubleClick = () => {

            if (!this.node.readOnly) {
                return this.openArea(this.node.areaInfo.name);
            }
        }

        this.setDrag = function() {
            if (this.node.readOnly) return d3.drag();

            let that = this;
            let drag = d3
                .drag()
                .on("start", that.dragstarted)
                .on("drag", (event, d) => that.dragged(event, d, that))
                .on("end", (event, d) => that.dragended(d, that));
            return drag;
        };

        this.dragstarted = function(event, d) {
            SingletonFlowchart.selectNode(`${d.idName}`);

            d3.select(this)
                .style("stroke", "black")
                .style("cursor", "grabbing");

            d3.selectAll(`#Area-${d.id} > .circleBox`).remove();
        };

        this.dragged = async function(event, d) {
            SingletonFlowchart.clicked = false;
            d.x = event.x;
            d.y = event.y;
             this.move();
          
        };

        this.drag = async function() {
            let d = this.node;
            this.moved = true;
            await d3
                .select(`.${d.idName}`)
                .raise()
                .attr("x", d.x)
                .attr("y", d.y);

            await d3
                .select(`#${d.idName} > text`)
                .raise()
                .attr("x", d.xText())
                .attr("y", d.yText());

            d.connectionPack = d.connectionPack.filter((point) =>
                d.decorator.ctrConnection.isAlive(point.conn)
            );
            d.connectionPack.forEach((point) => {
                let dot = d.decorator.getPointPosition(d, point.dot);
                point.conn.moveFirstPoint({ x: dot[0].x, y: dot[0].y });
            });
        };

        this.move = async function() {
            let d = this.node;

            await d3
                .select(`.${d.idName}`)
                .raise()
                .attr("x", d.x)
                .attr("y", d.y);

            await d3
                .select(`#${d.idName} > text`)
                .raise()
                .attr("x", d.xText())
                .attr("y", d.yText());

                resize.move(d)
            let conn = new Array();
            await SingletonFlowchart.selectedNodes.forEach((n) => {
                if (this.typeConn == n.type) {
                    conn.push(n);
                }
            });

            if (d.connectionPack.length > 0) {
                d.connectionPack = d.connectionPack.filter((point) =>
                    d.decorator.ctrConnection.isAlive(point.conn)
                );
                await d.connectionPack.forEach((point) => {
                    let isSelected = conn.includes(point.conn);
                    if (!isSelected) {
                        let dot = d.decorator.getPointPosition(d, point.dot);
                        point.conn.moveFirstPoint({ x: dot[0].x, y: dot[0].y });
                    }
                });
            }

            await d3.selectAll(`#${d.idName} > .circleBox`).remove();
            await d.decorator.createConnections(d);
        };

        this.dragended = function(node) {
            d3.select(`.Area-${node.id}`)
                .style("cursor", "grab")
                .style("stroke", "none");

            node.decorator.createConnections(node);
            if (this.moved) {
                SingletonFlowchart.SaveStatus();
                this.moved = false;
            }
        };

        this.getPointPosition = function(node, point) {
            return GetSixConections(node).filter((dot) => dot.point == point);
        };

        this.createConnections = function(node) {
            let connections = GetSixConections(node);

            d3.select(`#Area-${node.id}`)
                .selectAll(`.circle-${node.id}`)
                .data(connections)
                .join("circle")
                .attr("id", (d) => d.point + "-" + node.id)
                .classed("circleBox", true)
                .attr("cx", (d) => d.x)
                .attr("cy", (d) => d.y)
                .style("cursor", !node.readOnly ? "pointer" : "croshair")
                .attr("r", 7)
                .style("fill", "#0000")
                .on("mouseover", (event, d) => this.mouseOver(d, node))
                .on("mouseout", (event, d) => this.mouseOut(d, node))
                .call(this.setDragConnections(node))
                .node();
        };

        this.mouseOver = function(d, node) {
            if (this.node.readOnly) return;

            d3.select("#" + d.point + "-" + node.id).style(
                "fill",
                "rgba(255, 0, 0, 0.705)"
            );
        };

        this.mouseOut = function(d, node) {
            if (this.node.readOnly) return;

            d3.select("#" + d.point + "-" + node.id).style("fill", "#0000");
        };

        this.setDragConnections = function(node) {
            if (this.node.readOnly) return d3.drag();

            let that = this;
            let drag = d3
                .drag()
                .on("start", () => that.dragStartConnections(that, node))
                .on("drag", (event) => that.draggedConnections(event, that, node))
                .on("end", (event, node) =>
                    that.dragendedConnections(event, that, node)
                );

            return drag;
        };

        this.dragStartConnections = (that) => {
            that.connected = true;
        };

        this.draggedConnections = (event, that, node) => {
            if (that.connected && !that.transientConnection) {
                that.transientConnection = that.ctrConnection.setNewNode(
                    event.x,
                    event.y,
                    `#Area-${node.id}`,
                    node.areaInfo.colorConn,
                    that.dialog
                );
            }
            that.connected = false;
            that.transientConnection.startMoveConnection({ x: event.x, y: event.y });
        };

        this.dragendedConnections = (event, that, node) => {
            !that.connected &&
                that.node.connectionPack.push({
                    conn: that.transientConnection,
                    dot: node.point,
                });
            that.transientConnection = null;

            SingletonFlowchart.SaveStatus();
        }; 

        this.setAdjustArea = function () {
            let d = this.node;
      
            d3.select(`#${d.idName} > rect`)
              .attr("width", d.width)
              .attr("height", d.height)
              .attr("stroke-width", d.stroke)

          };
        this.updateImage = () => {
            d3.select(`#Area-${this.node.id} > image`).attr(
                "xlink:href",
                this.getImagePath(this.node)
            );
        };

        this.getImagePath = (node) => {
            if (node.areaInfo.image) {
                return require("@/assets/Fluxogramas/" + node.areaInfo.image);
            }
            return require("@/assets/Fluxogramas/ni.png");
        };
    }
}